import React from 'react';

export function BoldColumnFormatter(cellContent, size = 'medium') {
  const getSize = (size) => {
    switch (size) {
      case 'small': return 'sm';
      case 'xl': return 'h5';
      case 'medium':
      default: return 'lg';
    }
  }
  return (
    <div
      className={`text-dark-75 font-weight-bolder d-block font-size-${getSize(size)}`}
      data-text={cellContent}
    >
      {cellContent}
    </div>
  );
}
